import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as settings from "../settings";

export default function ArticleList({ isMobile }) {
    const navigate = useNavigate();
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        fetch('/articles.json')
            .then(response => response.json())
            .then(data => setArticles(data))
            .catch(error => console.error('Error fetching articles:', error));
    }, []);

    const clientArticles = articles.filter(article => article.targetAudience === "Client");
    const attorneyArticles = articles.filter(article => article.targetAudience === "Attorney");

    return (
        <>
            {/* Hero Section */}
            <div
                className="bg-dark text-light"
                style={{
                    minHeight: '60vh',
                    backgroundImage: `
            linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.7),
              rgba(0, 0, 0, 0.5)
            ),
url(${settings.SITEURL}/hero-bg.jpg)          `,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Container>
                    <Row className="justify-content-center text-center">
                        <Col lg={8}>
                            <h1 className="display-4 fw-bold">Latest Real Estate Insights</h1>
                            <p className="lead mt-3">
                                Expert advice, market trends, and tips to help you save on your next home transaction.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Articles Grid - For Clients */}
            <Container className="py-5">
                <h2 className="mb-4 fw-bold">For Clients</h2>
                <Row className="g-4">
                    {clientArticles.map((article) => (
                        <Col key={article.id} xs={12} md={6} lg={4}>
                            <ArticleCard article={article} navigate={navigate} />
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Articles Grid - For Attorneys */}
            <Container className="pb-5" style={{ marginBottom: "100px" }}>
                <h2 className="mb-4 fw-bold">For Attorneys</h2>
                <Row className="g-4">
                    {attorneyArticles.map((article) => (
                        <Col key={article.id} xs={12} md={6} lg={4}>
                            <ArticleCard article={article} navigate={navigate} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </>
    );
}

function ArticleCard({ article, navigate }) {
    return (
        <Card
            className="h-100 shadow-sm border-0 card-hover"
            style={{ borderRadius: '1rem', overflow: 'hidden', cursor: 'pointer' }}
            onClick={() => navigate(`/article/${article.slug}`)}
        >
            <div style={{ height: '200px', overflow: 'hidden' }}>
                <Card.Img
                    variant="top"
                    src={article.image}
                    style={{ height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
                />
            </div>
            <Card.Body className="d-flex flex-column p-4">
                <div className="text-muted small mb-2">{article.date}</div>
                <Card.Title className="fw-bold mb-3">{article.title}</Card.Title>
                <Card.Text className="text-secondary mb-4 flex-grow-1">
                    {article.summary}
                </Card.Text>
                <div className="mt-auto">
                    <Button variant="outline-primary" className="rounded-pill px-4">
                        Read More
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
}
